import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { ConvertMonthTH } from "../../widgets/form/ConvertTime";

const UnitGraph = ({ data }: any) => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const getAmount = () => {
      console.log('📊 UnitGraph - Raw Data:', data);

      // data จาก API มีโครงสร้าง [{ month: "2024-01", units: 150 }, ...]
      // แปลง units เป็น number เพื่อความแน่ใจ
      const months = data.map((val: any) => ConvertMonthTH(val.month));
      const units = data.map((val: any) => Number(val.units) || 0);

      console.log('📊 UnitGraph - Months (Labels):', months);
      console.log('📊 UnitGraph - Units (Values):', units);

      // หาค่าที่มากที่สุด
      const maxUnit = Math.max(...units);
      const maxIndex = units.indexOf(maxUnit);

      // สร้าง array ของสี โดยให้ค่าที่มากที่สุดเป็นสีเข้ม
      const backgroundColor = units.map((unit: number, index: number) => {
        return index === maxIndex ? '#7A8BC4' : '#abb4eb';
      });

      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue("--text-color");
      const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

      const graph_data = {
        labels: months,
        datasets: [
          {
            label: "จำนวนหน่วย",
            data: units,
            fill: false,
            borderRadius: 6,
            backgroundColor: backgroundColor,
            tension: 0.4,
          },
        ],
      };

      console.log('📊 UnitGraph - Graph Data:', graph_data);

      const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            labels: {
              color: textColor,
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#BEC4D0",
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: "#BEC4D0",
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },
      };

      setChartData(graph_data);
      setChartOptions(options);
    };

    getAmount();
  }, [data]);

  return (
    <Chart
      type="bar"
      data={chartData}
      options={chartOptions}
      style={{ height: "320px" }}
    />
  );
};

export default UnitGraph;
